import { ComponentProps, ReactNode } from 'react';

import styles from '@components/text/Link.module.css';
import Hyperlink from '@components/typography/Hyperlink';
import { maybeWrapElementInHoverText } from '@utils/htmlUtils';

type Props = ComponentProps<typeof Hyperlink> & {
  hoverContent?: ReactNode;
};

const Link = ({ children, hoverContent, ...linkProps }: Props) =>
  maybeWrapElementInHoverText(
    hoverContent,
    <Hyperlink className={styles.routerLink} {...linkProps}>
      {children}
    </Hyperlink>
  );

export default Link;
